const LINK_ACCOUNT_VIEW_PREFIX = "lav";

export const LINK_ACCOUNT_VIEW_TEST_IDS = {
    CONTAINER: `${LINK_ACCOUNT_VIEW_PREFIX}_container`,
    HEADER: `${LINK_ACCOUNT_VIEW_PREFIX}_header`,
    TITLE: `${LINK_ACCOUNT_VIEW_PREFIX}_title`,
    SUB_TITLE: `${LINK_ACCOUNT_VIEW_PREFIX}_subtitle`,
    METHOD_ICON: `${LINK_ACCOUNT_VIEW_PREFIX}_icon`,
    OTP_INPUT: `${LINK_ACCOUNT_VIEW_PREFIX}_otp`,
    NO_OTP_TEXT: `${LINK_ACCOUNT_VIEW_PREFIX}_no_otp`,
    CONFIRM_LINKING: `${LINK_ACCOUNT_VIEW_PREFIX}_confirm_linking`,
    RESEND_OTP_BUTTON: "resendOtpBtn",
    VERIFY_AND_PROCEES_BUTTON: "proceedBtn",
};
